module.exports = __webpack_public_path__ + "cardImageHolder.5e16444.png";